import { useCallback } from "react";
import { AssembleTypography } from "src/components/AssembleTypography";
import { StyledBlockButton } from "../StyledBlockButton/StyledBlockButton";

const HEADER_6 = "header-six";

export type H6BlockProps = {
  editorState: Draft.EditorState;
  onClick: (headline: string) => void;
};

export const H6Block = (props: H6BlockProps): JSX.Element => {
  const { editorState, onClick } = props;

  const startKey = editorState.getSelection().getStartKey();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(startKey)
    .getType();
  const active = blockType === HEADER_6;

  const onClickHeadline = useCallback(() => {
    onClick(HEADER_6);
  }, [onClick]);

  return (
    <StyledBlockButton active={active} onClick={onClickHeadline}>
      <AssembleTypography style={{ fontSize: "22px", fontWeight: "bold" }}>
        H6
      </AssembleTypography>
    </StyledBlockButton>
  );
};
